// tslint:disable:max-file-line-count
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { IOfferCardContext } from '../../index';

import { Underground } from '../../../common/components/underground';
import { Railway } from '../../../common/components/railway';
import { AddressItem } from '../../../common/components/address_item';
import { getRailway } from '../../../utils/getRailway';
import { getUnderground } from '../../../utils/getUnderground';

interface IAddressProps {
  currentPath: string | undefined;
  suggestionDistancesSeoText: string | undefined;
  qsToUris?: { [key: string]: string; };
  hideDot?: boolean;
}

export class Address extends React.Component<IAddressProps> {

  public context: IOfferCardContext;

  public static contextTypes = {
    api: PropTypes.object,
    experiments: PropTypes.array,
    isSimilar: PropTypes.bool,
    jsonQuery: PropTypes.object,
    offer: PropTypes.object,
    offerHelper: PropTypes.object,
  };

  public render() {
    const { offer } = this.context;
    const { qsToUris, hideDot, currentPath, suggestionDistancesSeoText } = this.props;
    const { geo } = offer;
    const railway = getRailway(offer);
    const underground = getUnderground(offer);

    const locationId = geo && geo.address.length > 0 ? geo.address[0].id : undefined;

    return (
      <>
        {underground && (
          <Underground
            hideDot={hideDot}
            locationId={locationId}
            onClick={this.handleUndergroundClick}
            underground={underground}
            url={qsToUris && qsToUris[underground.qs] || `/cat.php?${underground.qs}`}
          />
        )}
        {!underground && railway && <Railway railway={railway} />}
        <AddressItem
          currentPath={currentPath}
          qsToUris={qsToUris}
          suggestionDistancesSeoText={suggestionDistancesSeoText}
          underground={underground}
        />
      </>
    );
  }

  private handleUndergroundClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const { tracking } = this.context.api;
    if (tracking && tracking.trackAddressClick) {
      tracking.trackAddressClick('metro');
    }
    e.stopPropagation();
  }
}
